const Stockists = () => {
  const stockistsSection = document.querySelector(".stockists");

  if (stockistsSection) {
    const accordionItems = [...stockistsSection.querySelectorAll(".accordion__item")];

    if (accordionItems.length > 0 && window.innerWidth > 1023) {
      accordionItems[0].classList.add("opened");
    }
  }
}

export default Stockists;